module.exports = __webpack_public_path__ + "img/quanc_10.9eaaec24.png";